import { __extends } from "tslib";
import filterMixin from './filter-mixin';
var FilterBuilder = (function (_super) {
    __extends(FilterBuilder, _super);
    function FilterBuilder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(FilterBuilder.prototype, "constructorName", {
        get: function () {
            return 'FilterBuilder';
        },
        enumerable: false,
        configurable: true
    });
    FilterBuilder.prototype._build = function () {
        return this.getFilterModel();
    };
    return FilterBuilder;
}(filterMixin()));
export { FilterBuilder };
export function filterBuilder(params) {
    if (params === void 0) { params = {}; }
    return new FilterBuilder(params);
}
export default filterBuilder;
//# sourceMappingURL=filter-builder.js.map